export default {
  methods: {
    getUri () {
      const questionMarkPos = document.location.href.indexOf('?')
      const uri =
        questionMarkPos > -1
          ? document.location.href.substring(0, questionMarkPos)
          : document.location.href
      return uri
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/URI.js